import React, { useEffect, useRef } from "react";
import { ModalClose } from "./assets";
import { Button } from "./Button";

interface ModalProps {
  children?: React.ReactNode;
  className?: string;
  open: boolean;
  title?: string;
  subtitle?: string;
  footer?: React.ReactNode;
  onClose?: () => void;
  wider?: boolean;
}

export function Modal({
  children,
  /*className,*/
  onClose,
  open,
  title,
  subtitle,
  footer,
  wider,
}: ModalProps) {
  const [showModal, setShowModal] = React.useState(false);
  const modalRef = useRef<HTMLDialogElement | null>(null);

  useEffect(() => {
    setShowModal(open);
  }, [open]);

  useEffect(() => {
    const modal = modalRef.current;
    if (modal) {
      if (showModal) modal.showModal();
      else modal.close();
    }
  }, [open, showModal]);

  /*const handleOutsideClick = (e: any) => {
                                                            if (modalRef.current === e.target) {
                                                              setShowModal(false);
                                                              onClose && onClose();
                                                            }
                                                          };*/

  const handleCloseModal = () => {
    if (onClose) onClose();
    setShowModal(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDialogElement>) => {
    if (e.key === "Escape") {
      handleCloseModal();
    }
  };

  if (!open) return null;

  return (
    <dialog
      ref={modalRef}
      onKeyDown={handleKeyDown}
      className={`${wider ? "w-240" : "w-165"} shadow-modal rounded-xl`}
    >
      <div className="w-full bg-silver p-5 inline-flex flex-row flex-nowrap justify-between border border-b-blue">
        <h1 className="text-blue tracking-ultraWidest text-lg font-normal">
          {title}
        </h1>
        <Button type="close" htmlType="button" onClick={handleCloseModal}>
          <ModalClose style={{ fill: "#437EF7" }} />
        </Button>
      </div>
      <div className="w-full p-6">
        <h2 className="text-black tracking-ultraWidest text-lg font-bold">
          {subtitle}
        </h2>
        <div className="w-full px-8 bg-transparent flex flex-col flex-nowrap items-center">
          {children}
        </div>
      </div>
      {footer}
    </dialog>
  );
}
